import React from 'react';

function KamIcon() {
  return (
    <svg
      height="22.2"
      style={{ display: 'block' }}
      viewBox="0 0 22.2 22.2"
      width="22.2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(.6 .6)">
        <g
          data-name="Groupe 1568"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        >
          <path
            d="M21 21.001a19.9 19.9 0 00-2.282-7.572 6.832 6.832 0 00-2.276-2.328c-2.277-1.424-9.664-1.244-11.888 0a7.833 7.833 0 00-3.246 4.406A31.693 31.693 0 000 21.001zM14.632 4.084a4.246 4.246 0 01-1.2 2.89 3.921 3.921 0 01-2.895 1.193 4.084 4.084 0 114.1-4.083z"
            data-name="Tracé 218"
          />
          <path d="M0 5.785L0 0" data-name="Ligne 231" transform="translate(6.322 15.215)" />
          <path d="M0 5.785L0 0" data-name="Ligne 232" transform="translate(14.633 15.215)" />
        </g>
      </g>
    </svg>
  );
}

export default KamIcon;
